declare const __GOLDEN_ARTIFACT_CAPTURE__: boolean;
declare const __GOLDEN_ARTIFACT_CAPTURE_APPLY_EDITS_PPTX__: boolean;

export function isGoldenArtifactCaptureEnabled(): boolean {
  return typeof __GOLDEN_ARTIFACT_CAPTURE__ !== "undefined"
    ? Boolean(__GOLDEN_ARTIFACT_CAPTURE__)
    : false;
}

export function isGoldenApplyEditsPptxCaptureEnabled(): boolean {
  return typeof __GOLDEN_ARTIFACT_CAPTURE_APPLY_EDITS_PPTX__ !== "undefined"
    ? Boolean(__GOLDEN_ARTIFACT_CAPTURE_APPLY_EDITS_PPTX__)
    : false;
}

